import useSWRMutation from 'swr/mutation';
import baseFetcher from '../../shared/baseFetcher';
import { getOutcome } from '../../prequal/utils';

const fetcher = (key, { arg: { data, outcome } }) => baseFetcher({
  method: 'POST',
  url: key,
  data,
  ...getOutcome('pendingOutcome', outcome),
  timeout: 20_000,
});

const useCreateDecision = (prequalId, options) => useSWRMutation(`/prequals/${prequalId}/decisions`, fetcher, {
  ...options,
});

export default useCreateDecision;
